export default "__VITE_ASSET__DSEd8EXs__"